import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LEARNING_PORTFOLIO_FEATURE_KEY } from './keys';
import { learningPortfolioReducer } from './reducers/learning-portfolio.reducer';
import { LearningPortfolioEffects } from './effects/learning-portfolio.effects';

export const learningPortfolioStoreProviders = [
    provideState(LEARNING_PORTFOLIO_FEATURE_KEY, learningPortfolioReducer),
    provideEffects(LearningPortfolioEffects),
];

export { LearningPortfolioFacade } from './facades/learning-portfolio.facade';
export * from './models';
